import { useNavigation, useRoute } from '@react-navigation/native';
import { useSelector } from 'react-redux';

import { scheduledProductionOperationIdParam } from '@components/operatorPanel/constants/operatorPanel.constants';
import { selectScreenToBackFromJobPerspective } from '@reducers/operatorPanel';
import { selectSelectedItem } from '@reducers/machines';

export const useManageOPInformationTabsCrossIcon = () => {
  const route = useRoute();
  const navigation = useNavigation<any>();
  const selectedJobId = route?.params?.[scheduledProductionOperationIdParam];
  const isMachinePerspective = selectedJobId == null;

  const selectedMachine = useSelector(selectSelectedItem);
  const screenToBackFromJobPerspective = useSelector(selectScreenToBackFromJobPerspective);

  const onCrossIconPress = () => {
    if (!isMachinePerspective && screenToBackFromJobPerspective) {
      navigation.navigate(screenToBackFromJobPerspective);
    } else {
      navigation.navigate('OperatorPanel', { id: selectedMachine?.machineId });
    }
  };

  return { onCrossIconPress };
};
